export function Eyebrow({ children, dark = false, className = "", as: Tag = "div" }) {
  return (
    <Tag className={`flex items-center gap-3 ${className}`}>
      <span aria-hidden="true" className="h-px w-8 bg-[#A27B5B]" />
      <span
        className={`text-[0.72rem] font-medium uppercase tracking-[0.3em] ${
          dark ? "text-[#DCD7C9]" : "text-[#3F4E4F]"
        }`}
      >
        {children}
      </span>
    </Tag>
  );
}
